
<div class="container-fluid bg-blue " style="min-height: 100vh;" >
  <div class="container py-3 pb-4" *ngIf="loading">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center pt-20">
          <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-blue py-3 pt-15 text-center" *ngIf="!loading">
    <a class="profilePicture mt-n6" *ngIf="user==null">
      <img src="../../../assets/images/Linktree/templates/DumyUser.png" alt="Profile Picture" class="img-fluid shadow" style="border-radius: 50%; height: 90px;width: 100px;">
    </a>
    <a class="rounded-circle text-center" *ngIf="user!=null">
      <div class="avatar avatar-xxl">
        <img alt="avatar" src="{{user.image}}" class="rounded-circle shadow-lg shadowfilter" >
      </div>
    </a>
    <div class="userName pt-4 text-truncate" *ngIf="user!=null">
        {{user.userName}}
    </div>
    <div class="h4 text-truncate text-white text-center" *ngIf="user!=null">
        {{user.title}}
    </div>
    <div class="description text-truncate text-center" *ngIf="user!=null">
        {{user.description}}
    </div>

    <div class="d-flex justify-content-center" *ngIf="socialLink.length>0">
      <a class="btn btn-icon bg-white mx-1"  href="{{item.link}}" target="_blank" (click)="handleLinkClick($event, item.linkType, item.link, 'Click')" *ngFor="let item of socialLink">
          <i ngClass="{{getIconClass(item.link)}}"></i>
      </a>
   </div>
   <div class="links" *ngIf="linksData.length > 0">
    <a
      class="link shadow"
      [href]="item.link"
      (click)="handleLinkClick($event, item.linkType, item.link, 'Click')"
      *ngFor="let item of linksData"
    >
      <i [ngClass]="getIconClass(item.link)">&nbsp;</i>
      {{ item.linkType }}
    </a>
  </div>

  </div>
  <div class="container mb-14">
    <div class="row">
      <div class="col-lg-12">
        <div class="d-flex justify-content-center">
          <qrcode [qrdata]="Qr" [width]="200"></qrcode>
      </div>
      </div>
    </div>
  </div>
</div>


<div class="d-block d-sm-block d-md-block d-lg-none d-xl-none mt-10">
  <app-bottom-nav></app-bottom-nav>
</div>


